"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleStatus = void 0;
var VehicleStatus;
(function (VehicleStatus) {
    VehicleStatus[VehicleStatus["Pending"] = 0] = "Pending";
    VehicleStatus[VehicleStatus["Accepted"] = 1] = "Accepted";
    VehicleStatus[VehicleStatus["Declined"] = 2] = "Declined";
    VehicleStatus[VehicleStatus["Deleted"] = 3] = "Deleted";
})(VehicleStatus || (exports.VehicleStatus = VehicleStatus = {}));
//# sourceMappingURL=VehicleStatus.js.map